import { Popup, PopupFormData } from "../types/popup";
import { ApiResponse } from "../types/api";
import { api } from "./api";

export const popupService = {
  getAll: async (): Promise<Popup[]> => {
    const response = await api.get<ApiResponse<Popup[]>>("/api/admin/popup");
    return response.data.data;
  },

  getById: async (id: number): Promise<Popup> => {
    const response = await api.get<ApiResponse<Popup>>(`/api/admin/popup/${id}`);
    return response.data.data;
  },

  create: async (formData: PopupFormData, imageFile?: File): Promise<void> => {
    const multipartData = new FormData();
    multipartData.append("data", JSON.stringify(formData));
    if (imageFile) multipartData.append("image", imageFile);
    await api.post("/api/admin/popup", multipartData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  update: async (id: number, formData: PopupFormData, imageFile?: File): Promise<void> => {
    const multipartData = new FormData();
    multipartData.append("data", JSON.stringify(formData));
    if (imageFile) multipartData.append("image", imageFile);
    await api.put(`/api/admin/popup/${id}`, multipartData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/api/admin/popup/${id}`);
  },
};
